import { useProgression } from '@/hooks/useProgression';
import { useStreakTracker } from '@/hooks/useStreakTracker';
import { useLanguage } from '@/i18n/LanguageContext';

const StatsBar = () => {
  const { state } = useProgression();
  const { currentStreak } = useStreakTracker();
  const { t } = useLanguage();

  const todayKey = new Date().toISOString().split('T')[0];
  // Count rooms completed today (approximation via fragments collected today)
  const roomsToday = state.completedRooms.length; // total for now

  return (
    <div className="flex items-center justify-center gap-6 py-3 px-4 border border-border/10 rounded-xl bg-card/20">
      <div className="flex items-center gap-2 text-xs text-muted-foreground/50">
        <span className="text-foreground/70 font-medium">{roomsToday}</span>
        <span>{t('rooms_explored') || 'rooms explored'}</span>
      </div>
      <div className="w-px h-4 bg-border/20" />
      <div className="flex items-center gap-2 text-xs text-muted-foreground/50">
        <span className="text-foreground/70 font-medium">{currentStreak}</span>
        <span>{t('stats_streak') || 'day streak'}</span>
      </div>
      <div className="w-px h-4 bg-border/20" />
      <div className="flex items-center gap-2 text-xs text-muted-foreground/50">
        <span className="text-foreground/70 font-medium">{state.fragments.length}</span>
        <span>{t('fragments')}</span>
      </div>
    </div>
  );
};

export default StatsBar;
